export enum LadingType {
  LT15 = 15,
  LT16 = 16,
  LT17 = 17
}